import { createSlice } from "@reduxjs/toolkit";
import { StringOrNumber } from "../../types/global";
import { __financesApiClient } from "../../rest-api/client-instances-application-scoped";
import dayjs from "dayjs";

export type GlobalState = {
  global: {
    userId: string | undefined;
    userJwt: string;
    showCreateExpenseForm: boolean;
    showCreatePayInForm: boolean;
    isFABOpen: boolean;
    dateRange: [StringOrNumber, StringOrNumber],
  }
};

export const globalSlice = createSlice({
  name: 'global',
  initialState: {
    userId: null,
    userJwt: null,
    showCreateExpenseForm: false,
    showCreatePayInForm: false,
    isFABOpen: false,
    dateRange: [
      dayjs().subtract(15, 'day').startOf('day').toISOString(),
      dayjs().endOf('day').toISOString()
    ],
  },
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
      __financesApiClient.setUserId(action.payload);
    },
    setUserJwt: (stage, action) => {
      stage.userJwt = action.payload;
      __financesApiClient.setUserJwt(action.payload);
    },
    toggleShowCreateExpenseForm: (state, action) => {
      state.showCreateExpenseForm = action.payload ?? !state.showCreateExpenseForm;
    },
    toggleShowCreatePayInForm: (state, action) => {
      state.showCreatePayInForm = action.payload ?? !state.showCreatePayInForm;
    },
    toggleFAB: (state, action) => {
      state.isFABOpen = action.payload ?? !state.isFABOpen;
    },
    changeDateRange: (state, action) => {
      state.dateRange = action.payload ?? [];
    }
  }
});

export const {
  toggleFAB,
  toggleShowCreateExpenseForm,
  toggleShowCreatePayInForm,
  changeDateRange,
  setUserId,
  setUserJwt,

} = globalSlice.actions;

export default globalSlice.reducer;